import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import PowerGenerationHourMeterForm from '../Forms/PowerGenerationHourMeterForm';

const AddEditPowerGenerationHourMeterModal = ({
	establishment_id,
	dataPowerGenerationHourMeter,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Registrar'} Horómetro
			</ModalHeader>

			<PowerGenerationHourMeterForm
				establishment_id={establishment_id}
				dataPowerGenerationHourMeter={dataPowerGenerationHourMeter}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditPowerGenerationHourMeterModal;
